module.exports = __webpack_public_path__ + "static/banner-four-shape9-a3bd53f336950592ea7ff5348a234c4b.png";